import LazyRedactorEditor from "@pathwright/ui/src/components/richtext/LazyRedactorEditor"
import PropTypes from "prop-types"
import "./ContentMethodRichText.css"

// Use this component as a custom form input.
// See lib/core/components/form for spec.

const ContentMethodRichText = function (props) {
  const { value, config, placeholder, minHeight, onChange } = props

  return (
    <div className="ContentMethod__RichText Redactor--theme">
      <LazyRedactorEditor
        config={config}
        toolbarFixedTarget=".swiper-slide-active .ScrollView"
        toolbarFixedTargetRelative={true}
        placeholder={placeholder}
        minHeight={minHeight}
        onChange={(value) => onChange(value, props)}
        value={value}
      />
    </div>
  )
}

ContentMethodRichText.displayName = "ContentMethodRichText"

ContentMethodRichText.propTypes = {
  config: PropTypes.string.isRequired,
  placeholder: PropTypes.string.isRequired,
  minHeight: PropTypes.string.isRequired,
  onChange: PropTypes.func.isRequired
}

ContentMethodRichText.defaultProps = {
  config: "full",
  placeholder: "Write or paste content...",
  minHeight: "300px"
}

export default ContentMethodRichText
